export default __webpack_public_path__ + "static/media/trash-alt-solid-grey.d30f9ec5.svg";